var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1625_79838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 19.5846C15.794 19.5846 20.0846 15.294 20.0846 10.0013C20.0846 4.70857 15.794 0.417969 10.5013 0.417969C5.20857 0.417969 0.917969 4.70857 0.917969 10.0013C0.917969 15.294 5.20857 19.5846 10.5013 19.5846Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 19.5827C7.95964 19.5827 5.52209 18.573 3.72486 16.7758C1.92764 14.9786 0.917969 12.541 0.917969 9.99935C0.917969 7.45769 1.92764 5.02013 3.72486 3.22291C5.52209 1.42569 7.95964 0.416016 10.5013 0.416016V19.5827Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 19.5846C15.794 19.5846 20.0846 15.294 20.0846 10.0013C20.0846 4.70857 15.794 0.417969 10.5013 0.417969C5.20857 0.417969 0.917969 4.70857 0.917969 10.0013C0.917969 15.294 5.20857 19.5846 10.5013 19.5846Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.1176C7.37414 7.52795 7.54002 6.95008 7.85351 6.45067C8.16701 5.95126 8.61533 5.55068 9.14674 5.29516C9.67814 5.03964 10.271 4.93959 10.8568 5.00656C11.4426 5.07354 11.9976 5.30481 12.4576 5.67367C12.9176 6.04254 13.264 6.53397 13.4567 7.09125C13.6494 7.64852 13.6805 8.24893 13.5466 8.82316C13.4127 9.3974 13.1191 9.92206 12.6998 10.3366C12.2804 10.7511 11.7524 11.0386 11.1767 11.1659C10.9878 11.2032 10.8175 11.3043 10.6943 11.4522C10.5711 11.6001 10.5025 11.7859 10.5 11.9784V12.9059",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 14.9941C10.5425 14.9941 10.5828 15.0064 10.617 15.0293C10.6513 15.0521 10.678 15.0847 10.6938 15.1227C10.7095 15.1608 10.7137 15.2027 10.7056 15.2431C10.6976 15.2835 10.6778 15.3207 10.6486 15.3498C10.6195 15.3789 10.5824 15.3988 10.5419 15.4068C10.5015 15.4148 10.4596 15.4107 10.4216 15.3949C10.3835 15.3792 10.351 15.3525 10.3281 15.3182C10.3052 15.284 10.293 15.2437 10.293 15.2025C10.293 15.1472 10.3149 15.0942 10.354 15.0552C10.3931 15.0161 10.446 14.9941 10.5013 14.9941Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1625_79838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroIcon);
export default __webpack_public_path__ + "static/media/intro_icon.f5b66a02b3b43b973bd3f9224e421b5e.svg";
export { ForwardRef as ReactComponent };